import Axios from 'axios';
import { ActionError } from 'Interfaces/ActionCreators';
import { NormalizedEntity } from 'Interfaces/Common';
import { RequestHistoryItem } from 'Interfaces/RequestsHistory';
import { keyBy } from 'lodash-es';
import { call, cancelled, put, takeLatest } from 'redux-saga/effects';
import RequestHistoryApi from 'Services/Api/RequestHistory';

import { getRequestHistory } from './actionCreators';

function* handleRequestHistoryGet({
  payload,
  meta,
}: ReturnType<typeof getRequestHistory.request>) {
  const cancelToken = Axios.CancelToken.source();
  const { apiKeyId, ...restParams } = payload;
  try {
    const { items, totalItems, pageCount, itemCount } = yield call(
      RequestHistoryApi.getRequestHistory,
      restParams,
      apiKeyId,
      {
        cancelToken: cancelToken.token,
      },
    );
    const normalizedRequestHistory: NormalizedEntity<RequestHistoryItem> = keyBy(
      items,
      'id',
    );

    yield put(
      getRequestHistory.success(
        {
          requestHistory: normalizedRequestHistory,
          paginationData: { totalItems, pageCount, itemsCount: itemCount },
        },
        meta,
      ),
    );
  } catch (error) {
    yield put(getRequestHistory.failure(error as ActionError, meta));
  } finally {
    if (yield cancelled()) {
      yield put(getRequestHistory.cancel(undefined, meta));
      cancelToken.cancel();
    }
  }
}

export default [takeLatest(getRequestHistory.request, handleRequestHistoryGet)];
